<template>
    <header id="header">
        <div class="container">
            <div class="header-top">
                <div class="title-app">
                    <Widget position="main_title"/>
<!--                    <h1>Национальный доклад о состоянии окружающей среды Кыргызской Республики</h1>-->
                </div>
                <Navigation />
            </div>
        </div>
    </header>
</template>

<script>
    import Navigation from "@/components/Navigation";
    import Widget from "@/components/app/Widget";

    export default {
        name: "Header",
        components: {
            Navigation,
            Widget
        }
    }
</script>

<style scoped>

</style>
